import comp from "./FieldDropdown";
export default comp;
